export default __webpack_public_path__ + "static/media/03_ethereum_46X250px.a91fc93d.svg";